//#region src/compat/util/stubFalse.ts
function stubFalse() {
	return false;
}
//#endregion
export { stubFalse };
